/**
 * TanStack Query hooks for `quarterly-award-recognition`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	quarterlyAwardRecognitionQueryKeys,
	type CreateQuarterlyAwardRecognitionBody,
	type ListQuarterlyAwardRecognitionResponse,
	type QuarterlyAwardRecognitionRow,
} from "./api";

export function useQuarterlyAwardRecognitionList(): UseQueryResult<ListQuarterlyAwardRecognitionResponse, Error> {
	return useQuery({
		queryKey: quarterlyAwardRecognitionQueryKeys.list(),
		queryFn: list,
	});
}

export function useQuarterlyAwardRecognitionCreate(): UseMutationResult<QuarterlyAwardRecognitionRow, Error, CreateQuarterlyAwardRecognitionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: quarterlyAwardRecognitionQueryKeys.all });
		},
	});
}

export function useQuarterlyAwardRecognitionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: quarterlyAwardRecognitionQueryKeys.all });
		},
	});
}
